import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { first } from 'rxjs/operators';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { PurchOrdSupLst } from 'src/app/shared/models/PurchOrdSupLst';
import { Constants } from 'src/app/shared/vo/Constants';
import { Table } from 'primeng/table';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';

@Component({
  selector: 'app-querys-view',
  templateUrl: './querys-view.component.html',
  styleUrls: ['./querys-view.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class QuerysViewComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;

  /** LABELS */
  lbl_go_Back: string = "back_";
  lbl_language: string = "language_";
  lbl_period: string = "period_";
  lbl_schedule: string = "schedule_";
  lbl_participants: string = "participants_";
  lbl_new_record: string = "new_record_";
  lbl_name: string = "name_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_email: string = "email_";
  lbl_gender: string = "gender_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_";
  lbl_search: string = "search_";
  lbl_particp15s: string = "10a15a_particip_";
  lbl_participants_12: string = "participants_";
  lbl_participants_1st: string = "participants_2nd_sesion_";
  lbl_future_guide: string = "future_guide_";
  lbl_partic_partner: string = "partic_partners_";
  lbl_no_sent: string = "no_sent_";
  lbl_age: string = "age_";
  lbl_school_prep_guides: string = "school_prep_guides_";
  lbl_comments: string = "comments_";
  lbl_date: string = "date_";
  lbl_save: string = "save_";
  lbl_guide_id: string = "guide_id_";
  lbl_certificate: string = "certificate_";
  lbl_change_Status_Guide_or_Comment: string = "change_Status_Guide_or_Comment";
  lbl_coordination: string = "coordination_";
  lbl_guideId: string = "guideId_";
  lbl_status: string = "status_";
  lbl_leaving_reason: string = "leaving_reason_";
  lbl_select: string = "select_";
  lbl_send: string = "send_";
  lbl_guide: string = "guide_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_updated_data: string = "updated_data_";
  lbl_delete_record: string = "delete_record_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_total: string = "total_";
  lbl_vendor: string = "vendor_";
  lbl_OR_vendor_quote: string = "OR_vendor_quote_";
  lbl_new: string = "new_";
  lbl_orders_request: string = "orders_request_";
  lbl_req_Date: string = "req_Date_";
  lbl_currency: string = "currency_";


  /** COMPONENT TABLE */
  @ViewChild('dt') table: Table; // Asegúrate de que el nombre 'dt' coincida con el valor de la propiedad tableStyleClass en el componente p-table
  data: Record<string, any>[];
  cols: any[];
  endPointFindPurchordhByStoreId = "getDynQuery";
  rowsPerPage: number = 50; // Cambia esto según tus necesidades

  qryId:string;
  listPeriods: PeriodsVO[];
  selectedPeriod: PeriodsVO;
  queryName:string;

  

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /**
   * This is a constructor function that initializes various services and variables used in the
   * component.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user.
   * @param {PurchOrdSupLstService} purchOrdSupLstServiceTest - This parameter is an instance of the
   * PurchOrdSupLstService class. It is used to perform operations related to the purchase order
   * supplier list.
   * @param {ConfirmationService} confirmationService - This parameter is used to display confirmation
   * dialogs to the user. It is provided by the ConfirmationService class.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API calls.
   * @param {Router} router - The `router` parameter is used for routing and navigation in Angular. It
   * allows you to navigate to different components and pass data between them.
   * @param {ActivatedRoute} route - The `route` parameter is used to access the current route's
   * information, such as the URL parameters and query parameters. It is an instance of the
   * `ActivatedRoute` class, which is provided by the Angular Router.
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user-related functionalities such as login, logout, and user information.
   * @param {TovpilUtilsService} tovpilUtils - TovpilUtilsService is a service that provides utility
   * functions for the Tovpil application. It may include functions for formatting data, manipulating
   * strings, or performing common calculations.
   * @param {TovpilFilesService} filesService - TovpilFilesService is a service that handles file-related
   * operations such as uploading, downloading, and deleting files.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService,
    private tovpilCrudService: TovpilCrudService) {

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
        this.storeId = params.storeId;
        this.qryId=params.qryId;
      });
    
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();
  }

  

  /**
   * The function `getSecurity()` retrieves security data and then calls another function to get
   * translated labels.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();
          
          this.getValidPeriods();

        });
    } else {
      this.getTranslatedLabels();
    }
  }

  /**
   * The function `getLstData` makes a fetch request with specific parameters.
   */
  getLstData() {
    console.log(this.security);
    this.fetch({
      "year": this?.selectedPeriod ? this.selectedPeriod.year : 2023,
      "period": this?.selectedPeriod ? this.selectedPeriod.period : 1,
      "storeId": this?.security?.storeId ? this.security.storeId : '0000000003',
      "queryId": this.qryId,
      "language": this?.security?.language ? this.security.language : 'es'
    });
  }

  /**
   * The function `loadPurchOrdSup` loads purchase order data and populates various lists based on the
   * data.
   */
  fetch(requestParams: any) {
    this.blocked = true;
    console.debug("Fetching to: ", this.endPointFindPurchordhByStoreId, "with ", requestParams);
    this.tovpilCrudService.fetch(this.endPointFindPurchordhByStoreId, requestParams).then(result => {
      console.debug("Server Response: ", result)
      if (result.success) {
        this.queryName=result.data.queryName;
        this.handleSuccess(result.data);
      } else {
        console.error("An error occurred while fetching purchase order data:");
        this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }
    }).finally(() => {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    });
  }

  /**
   * The handleSuccess function handles the successful response from an API call by extracting columns
   * from the JSON data, assigning the data to an array, and calculating the number of rows per page.
   * @param {any[]} data - The `data` parameter is an array of objects. Each object represents a row of
   * data in a table.
   */
  handleSuccess(data: any[]) {
    try {
      if (data && data['headers'].length > 0 && data && data['records'].length > 0) {
        
        const { headerFieldRelationship, formattedRecords } = this.tovpilCrudService.formatData(data['headers'], data['records']);
        this.cols = headerFieldRelationship;
        this.data = formattedRecords;
      } else {
        this.data = null;
        this.cols = null;
        this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }

      // console.log(this.data);
      // console.log(this.cols);
    } catch (error) {
      console.error('An error occurred:', error);
      this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  handleError(message: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    window.close();
  }

  /**
   * The function `getTranslatedLabels` retrieves translated labels from an API and assigns them to
   * corresponding variables.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_language, this.lbl_period, this.lbl_participants, this.lbl_new_record, this.lbl_name, this.lbl_cell_phone, this.lbl_email, this.lbl_gender, this.lbl_edit, this.lbl_delete, this.lbl_search, this.lbl_particp15s, this.lbl_participants_12, this.lbl_participants_1st, this.lbl_future_guide, this.lbl_partic_partner, this.lbl_no_sent, this.lbl_age, this.lbl_school_prep_guides, this.lbl_comments, this.lbl_date, this.lbl_save, this.lbl_guide_id, this.lbl_certificate, this.lbl_change_Status_Guide_or_Comment, this.lbl_coordination, this.lbl_guideId, this.lbl_status, this.lbl_leaving_reason, this.lbl_select, this.lbl_send, this.lbl_guide, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_updated_data, this.lbl_delete_record, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_total, this.lbl_vendor, this.lbl_OR_vendor_quote, this.lbl_new, this.lbl_orders_request, this.lbl_req_Date, this.lbl_currency]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_language = map.get(this.lbl_language);
        this.lbl_period = map.get(this.lbl_period);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_particp15s = map.get(this.lbl_particp15s);
        this.lbl_participants_12 = map.get(this.lbl_participants_12);
        this.lbl_participants_1st = map.get(this.lbl_participants_1st);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_partic_partner = map.get(this.lbl_partic_partner);
        this.lbl_no_sent = map.get(this.lbl_no_sent);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_school_prep_guides = map.get(this.lbl_school_prep_guides);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_date = map.get(this.lbl_date);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_change_Status_Guide_or_Comment = map.get(this.lbl_change_Status_Guide_or_Comment);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_leaving_reason = map.get(this.lbl_leaving_reason);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_vendor = map.get(this.lbl_vendor);
        this.lbl_OR_vendor_quote = map.get(this.lbl_OR_vendor_quote);
        this.lbl_new = map.get(this.lbl_new);
        this.lbl_orders_request = map.get(this.lbl_orders_request);
        this.lbl_req_Date = map.get(this.lbl_req_Date);
        this.lbl_currency = map.get(this.lbl_currency);

      });

  }


  /**
   * This function exports data to an Excel file, but displays error messages if there is no data or if
   * the data list is empty.
   */
  exportExcel() {
    try {
      if (this.data === null) {
        this.messageService.add({
          severity: 'error',
          summary: 'No existe información para procesar',
          life: 3000
        });
      } else if (this.data.length < 1) {
        this.messageService.add({
          severity: 'error',
          summary: 'La lista está vacía',
          life: 3000
        });
      } else {
        const filteredJSON = this.data.map((item) => {
          const dynamicColumns = this.cols.map((col) => ({
            [col.header]: item ? item[col.field] || 'S/N' : 'S/N'
          }));
          return Object.assign({}, ...dynamicColumns);
        });
        this.filesService.tovpilExportXLSX(filteredJSON, 'listPurchOrdSup_');
      }
    } catch (error) {
      console.error("An error occurred:", error);
      this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }


  /**
   * The exportPdf function exports data to a PDF file, but displays error messages if there is no data
   * or if the data list is empty.
   */
  exportPdf() {
    try {
      if (this.data === null) {
        this.messageService.add({
          severity: 'error',
          summary: 'No existe información para procesar',
          life: 3000
        });
      } else if (this.data.length < 1) {
        this.messageService.add({
          severity: 'error',
          summary: 'La lista está vacía',
          life: 3000
        });
      } else {
        const filteredJSON = this.data.map((item) => {
          const dynamicColumns = this.cols.map((col) => ({
            [col.header]: item ? item[col.field] || 'S/N' : 'S/N'
          }));
          return Object.assign({}, ...dynamicColumns);
        });

        const keysArray = filteredJSON.map((item) => Object.keys(item));
        const valuesArray = filteredJSON.map((item) => Object.values(item));

        this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listPurchOrders_');
      }
    } catch (error) {
      console.error("An error occurred:", error);
      this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
  }
  getValidPeriods() {
    this.apiService.getValidPeriods(this.security.language).then(
      data => {
        this.listPeriods = data;
        this.selectedPeriod = this.listPeriods[0];
        this.getLstData();
      });
  }
}
